import React, {Component} from 'react';
import '@amzn/awsui-global-styles/polaris.css';
import {
    Button,
    Form,
    FormField,
    DatePicker,
    Header,
    Container,
    ColumnLayout,
    Box,
    ButtonDropdown,
    SpaceBetween
} from "@amzn/awsui-components-react";
import CONSTANT, { IC_SETTLEMENTS_LDAP } from "../utils/constant";
import { safeParseComments } from "../utils/commentParser";
import APIClient from "../utils/apiClient";
import Logger from "../utils/logger";
import {
    VISIBLE_COLUMN_OPTIONS_HISTORICAL_PAYMENT,
    DOWNLOAD_SETTLEMENTS_DROPDOWN_ITEMS
} from "../config/table";
import moment from "moment-timezone";
import FormatData from "../utils/formatData";
import DataContentTable from "../component/dataContentTable";
import BatchUpdatePaymentModal from "./common/modal/batchUpdatePaymentModal";
import UpdatePaymentModal from "./common/modal/updatePaymentModal";
import CommentModal from "./common/modal/commentModal";
import DownloadPaymentModal from "./common/modal/downloadPaymentModal";
import {getStage} from "../utils/environment";
import {DOWNLOAD_FILE_PAYMENT_DELIMITER} from "../config/file";
import xlsxParser from "../utils/xlsxParser";
import {
    getFeedbackMessage,
    getFirstDayOfTheMonthInDateString,
    getCurrentDateInDateString,
    getLatestComment,
    populateRegion,
    lookupBranch
} from "./common/paymentRecordTableCommon";
import { ldapMembershipAlert } from "../utils/polarisAlerts";
import { arrayIntersection } from  '../utils/arrayIntersection';
import {NoDocumentModal} from "../document/noDocumentModal";
import {QueryDocumentData} from "../document/queryDocumentData";
import {hasDocumentAttached} from "../document/upload/documentUtils";
import SingleDocumentModule from "../document/upload/singleDocumentModule";
import {queryDocuments} from "./common/modal/documentQueryHelper";

/*
 * UI container that renders the historical payments data table and the action items bar.
 */
class HistoryPaymentDataContentBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let commentsDisabled = true;
        let downloadDisabled = false;
        let updateDisabled = true;
        let selectedElement = {};
        let updateWindow = "";
        let batchUpdateWindow = "";
        let viewDocumentButton = <></>;
        let singleUploadDisabled = true;

        //Determine whether user actions are allowed based on selected items.
        if (this.props.elementSelected.length > 0) {
            if (this.props.elementSelected.length === 1) {
                updateDisabled = false;
                commentsDisabled = false;
                selectedElement = this.props.elementSelected[0];
                singleUploadDisabled = false;
                //update Window
                updateWindow = <UpdatePaymentModal handleConfirmUpdateClick={this.props.handleConfirmUpdateClick}
                                                   updateWindowVisible={this.props.updateWindowVisible}
                                                   selectedPayment={selectedElement}
                                                   elementSelected={this.props.elementSelected}
                                                   handleDismissClick={this.props.handleDismissClick}
                                                   accountCategoryToRegionMap={this.props.accountCategoryToRegionMap}
                                                   companyCodeToKyribaBankAccountsMap={this.props.companyCodeToKyribaBankAccountsMap}
                                                   fxRequiringCurrencyMapping={this.props.fxRequiringCurrencyMapping}
                                                   weekendCalendarMapping={this.props.weekendCalendarMapping}
                                                   holidayCalendarMapping={this.props.holidayCalendarMapping}
                                                   currencyToDecimalDigitMapping={this.props.currencyToDecimalDigitMapping}
                                                   disableOverrideButton={this.props.disableOverrideButton}
                                                   user={this.props.user}/>;
            } else {
                batchUpdateWindow = <BatchUpdatePaymentModal handleConfirmBatchUpdateClick={this.props.handleConfirmBatchUpdateClick}
                                                             batchUpdateWindowVisible={this.props.batchUpdateWindowVisible}
                                                             elementSelected={this.props.elementSelected}
                                                             handleDismissClick={this.props.handleDismissClick}
                                                             user={this.props.user}
                                                             rejectionDisabled={true}/>;
            }
            // view document button should display if any of the selectedIds has a document attached
            const selectedIds = this.props.elementSelected.map(item => item[CONSTANT.PR_COL_SETTLEMENT_ID]);
            let shouldDisplayViewDocumentButton = false;
            selectedIds.forEach(recordId => {
                if (hasDocumentAttached(recordId, this.props.recordIdToDocumentIdMapping)) {
                    shouldDisplayViewDocumentButton = true;
                }
            });
            viewDocumentButton = shouldDisplayViewDocumentButton ?
                <Button onClick={() =>this.props.handleQueryDocument()}>View Documents</Button> : "";
        }

        //Comment window
        let commentModal = <CommentModal commentVisible={this.props.commentVisible}
                                         handleDismissClick={this.props.handleDismissClick}
                                         handleAddCommentClick={this.props.handleAddCommentClick}
                                         elementSelected={this.props.elementSelected}
                                         newComment={this.props.newComment}
                                         handleCommentUpdate={this.props.handleCommentUpdate}
                                         userComments={this.props.userComments}/>

        //Download Payment window
        let paymentDownloadModal =
            <DownloadPaymentModal downloadWindowVisible = {this.props.downloadWindowVisible}
                                  handleDismissClick={this.props.handleDismissClick}
                                  handleConfirmDownloadClick={this.props.handleConfirmDownloadClick}
                                  elementSelected={this.props.elementSelected}
                                  ifDownloadAll={this.props.ifDownloadAll}/>

        //Construct the action Item bars for the dataContentTable
        let tableHeader = <></>;
        if (this.props.userGroup.includes(CONSTANT.USER_GROUP_INTERCOMPANY) ||
            this.props.userGroup.includes(CONSTANT.USER_GROUP_PROD_ADMIN) ||
            (this.props.userGroup.includes(CONSTANT.USER_GROUP_DEVELOPER) &&
                getStage() !== 'prod')) {
            tableHeader =
                    
            <SpaceBetween direction="vertical" size="m">
                    {this.props.feedbackMessage}
                    {this.props.searchBar}
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button disabled={singleUploadDisabled}
                                    onClick={() => this.props.handleSingleDocumentClick()}>Single Upload Document</Button>
                            <Button disabled={updateDisabled}
                                    onClick={() => this.props.handleViewUpdateWindowClick()}>Update</Button>
                            <Button name="Comments"
                                    disabled={commentsDisabled}
                                    onClick={() => this.props.handleViewCommentClick()}>Add/View Comments</Button>
                            <ButtonDropdown
                                items={DOWNLOAD_SETTLEMENTS_DROPDOWN_ITEMS}
                                onItemClick={(event) => this.props.handleViewDownloadWindowClick(event.detail.id)}
                                disabled={downloadDisabled}>
                                Download
                            </ButtonDropdown>
                            {viewDocumentButton}
                        </SpaceBetween>
                    </Box>
                </SpaceBetween>;
        } else if (this.props.userGroup.includes(CONSTANT.USER_GROUP_CASH_POSITIONER) ||
            this.props.userGroup.includes(CONSTANT.USER_GROUP_SETTLEMENT_HISTORICAL)){
            tableHeader =
                <SpaceBetween direction="horizontal" size="xs">
                    {this.props.feedbackMessage}
                    {this.props.searchBar}
                    <Box float="right">
                        <Button disabled={singleUploadDisabled}
                                onClick={() => this.props.handleSingleDocumentClick()}>Single Upload Document</Button>
                        <Button name="Comments"
                                disabled={commentsDisabled}
                                onClick={() => this.props.handleViewCommentClick()}>Add/View Comments</Button>
                        <ButtonDropdown
                            items={DOWNLOAD_SETTLEMENTS_DROPDOWN_ITEMS}
                            onItemClick={(event) => this.props.handleViewDownloadWindowClick(event.detail.id)}
                            disabled={downloadDisabled}>
                            Download
                        </ButtonDropdown>
                        {viewDocumentButton}
                    </Box>
                </SpaceBetween>;
        }

        return (
            <Form>
                <Container header={<Header>Query Historical Settlements Data</Header>}>
                    <div>
                        {commentModal}
                    </div>
                    <div>
                        {updateWindow}
                    </div>
                    <div>
                        {batchUpdateWindow}
                    </div>
                    <div>
                        {paymentDownloadModal}
                    </div>
                    <div data-awsui-column-layout-root={true}>{
                        <DataContentTable distributions={
                                                this.props.companyCodeToKyribaBankAccountsMap &&
                                                this.props.accountCategoryToRegionMap &&
                                                this.props.fxRequiringCurrencyMapping &&
                                                this.props.weekendCalendarMapping &&
                                                this.props.holidayCalendarMapping &&
                                                this.props.recordIdToDocumentIdMapping ? this.props.distributions : []
                                          }
                                          contentSelectorOptions={this.props.contentSelectorOptions}
                                          filterOptions={this.props.filterOptions}
                                          columnDefinitions={this.props.columnDefinitions}
                                          header={tableHeader}
                                          onRowClick={this.props.onRowClick}
                                          sortableColumns={this.props.sortableColumns}
                                          elementSelected={this.props.elementSelected}
                                          onSelectionChange={this.props.onSelectionChange}/>
                    }</div>
                </Container>
            </Form>);
    }
}

/*
 *  QueryHistoryPayment Parent class that wraps the above UI container and routes the business logic handlers.
 */
class QueryHistoryPaymentData extends Component {
    constructor(props) {
        super(props);
        moment.tz.setDefault(CONSTANT.MOMENT_PST_TIMEZONE);
        this.state = {
            status: CONSTANT.MODAL_EMPTY,
            statusMsg: "",
            loading: false,
            distributions: [],
            companyCodeToKyribaBankAccountsMap: [],
            accountCategoryToRegionMap: [],
            fxRequiringCurrencyMapping: [],
            weekendCalendarMapping: [],
            holidayCalendarMapping: [],
            currencyToDecimalDigitMapping: [],
            recordIdToDocumentIdMapping: {},
            recordIdToDocumentIdMappingLoaded: false,
            elementSelected: [],
            userGroup: localStorage.getItem(CONSTANT.USER_GROUP_NAME),
            user: localStorage.getItem(CONSTANT.LOCAL_STORAGE_USERID),
            fromValue: getFirstDayOfTheMonthInDateString(),
            toValue: getCurrentDateInDateString(),
            newComment: '',
            commentsList: 0,
            userComments: {'userComment': [], 'commentId': ''},
            commentVisible: false,
            updateWindowVisible: false,
            batchUpdateWindowVisible: false,
            downloadWindowVisible: false,
            ifDownloadAll: true,
            disableOverrideButton: false,
            documentData:[],
            documentVisible: false,
            singleUploadVisible: false,
            icLdapOverlap: arrayIntersection(IC_SETTLEMENTS_LDAP, localStorage.getItem(CONSTANT.USER_GROUP_NAME)),
        }
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCommentUpdate = this.handleCommentUpdate.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    /**
     * Function for row click in the data table.
     * The elementSelected is the row selected.
     */
    onRowClick = ({detail}) => {
        let newElementSelected = [...this.state.elementSelected];
        if (newElementSelected.includes(detail.item)) {
            newElementSelected = newElementSelected.filter(x => x !== detail.item)
        } else {
            newElementSelected.push(detail.item)
        }
        this.onSelectionChange({detail: {selectedItems: newElementSelected}});
    };

    // queryDocuments for the queryDocumentData page.
    handleQueryDocument = async () => {
        this.setState({
            status: CONSTANT.MODAL_QUERYING
        });

        const selectedIds = this.state.elementSelected.map(item => item[CONSTANT.PR_COL_SETTLEMENT_ID]);
        const result = await queryDocuments(selectedIds);

        switch (result.status) {
            case CONSTANT.RESPONSE_SUCCESS:
                this.setState({
                    documentData: result.documentData,
                    documentVisible: true,
                });
                Logger.logInfo("Query Document Data succeeded.");
                break;
            case CONSTANT.RESPONSE_ERROR:
                Logger.logError("Error Query Document Data = " + this.state.elementSelected.toString());
                this.setState({
                    documentVisible: false,
                    status: CONSTANT.MODAL_QUERY_ERROR
                });
                break;
            case CONSTANT.RESPONSE_SYSTEM_ERROR:
                Logger.logError("System Error when Query Document Data = " + this.state.elementSelected.toString());
                this.setState({
                    status: CONSTANT.MODAL_SYSTEM_ERROR,
                    statusMsg: JSON.stringify(result.errorMessage)
                });
                break;
            case CONSTANT.MODAL_OTHER_ERROR:
                Logger.logError("Other System Error when Query Document Data");
                this.setState({
                    status: CONSTANT.MODAL_OTHER_ERROR,
                    statusMsg: "Other System Error when query document data records."
                });
                break;
            default:
                Logger.logError("Unhandled response status:", result.status);
                this.setState({
                    status: CONSTANT.MODAL_OTHER_ERROR,
                    statusMsg: "Received unknown response status"
                });
        }
    }


    handleQueryHistoricalSettlements = async () => {
        Logger.logInfo('handleQuery');

        this.setState({
            elementSelected: [],
            loading: true,
            status: CONSTANT.MODAL_QUERYING
        });

        Logger.logInfo('fromValue: ' + this.state.fromValue + ' toValue: ' + this.state.toValue);

        let allPayments = [];
        let paginationToken = null;

        try {
            do {
                const parameter = {
                    indexString: CONSTANT.INDEX_STRING_HISTORIC_PAYMENT_REVIEW,
                    userGroup: this.state.userGroup,
                    fromValue: this.state.fromValue,
                    toValue: this.state.toValue
                };

                if (paginationToken) {
                    parameter.paginationToken = paginationToken;
                }

                Logger.logInfo('ISO parameter: ' + JSON.stringify(parameter));

                const data = await new Promise((resolve, reject) => {
                    APIClient.invoke('GET', 'payment', parameter, undefined, (err, data) => {
                        if (err) reject(err);
                        else resolve(data);
                    });
                });

                Logger.logInfo("Data retrieved: " + JSON.stringify(data));

                switch (data.status) {
                    case CONSTANT.RESPONSE_SUCCESS:
                        allPayments.push(...data.data.items);
                        paginationToken = data.data.paginationToken;
                        Logger.logInfo("Fetched " + data.data.items.length + " items, token: " + paginationToken);
                        break;
                    case CONSTANT.RESPONSE_SYSTEM_ERROR:
                        Logger.logError("System Error when Querying historic settlemnts data records ");
                        this.setState({
                            loading: false,
                            status: CONSTANT.MODAL_SYSTEM_ERROR,
                            statusMsg: JSON.stringify(data['errorData'])
                        });
                        return;
                    case CONSTANT.MODAL_REQUEST_ERROR:
                        Logger.logError("Request Error when Querying historic settlemnts data records ");
                        this.setState({
                            loading: false,
                            status: CONSTANT.MODAL_REQUEST_ERROR,
                            distributions: data.data.items || [],
                            statusMsg: JSON.stringify(data['errorData'])
                        });
                        return;
                    default:
                        throw new Error('Unknown response status');
                }
            } while (paginationToken);

            Logger.logInfo("Total payments fetched: " + allPayments.length);
            this.setState({
                loading: false,
                status: CONSTANT.MODAL_UPDATE_SUCCESS,
                distributions: allPayments
            });
        } catch (err) {
            Logger.logError("Other Error when Querying historic settlemnts data records: " + JSON.stringify(err));
            this.setState({
                loading: false,
                status: CONSTANT.MODAL_OTHER_ERROR,
                statusMsg: `Error querying Historical Payments: ${err?.message || err?.statusCode || JSON.stringify(err)}`
            });
        }
    }

    componentDidMount() {
        Logger.logInfo('componentDidMount');
        
        /**
         * No processing is needed if the user is in more than one IC Settlements group, as the module
         * will simply return a Polaris Alert asking the user to remove themselves from all
         * but one IC settlement group before proceeding.
         */
        if (this.state.icLdapOverlap.length > 1) {
            return;
        }
        this.handleQueryHistoricalSettlements();

        // Get All Kyriba Bank Accounts Information as CompanyCode->KyribaBankAccountRecordsList Map
        var parameterGetKyribaBankAccount = {dataType: CONSTANT.QUERY_STRING_PARAM_TYPE_KYRIBA_BANK_ACCOUNT};
        APIClient.invoke('GET', 'queryKyribaData', parameterGetKyribaBankAccount,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                companyCodeToKyribaBankAccountsMap: data.data
                            });
                            Logger.logInfo("companyCodeToKyribaBankAccountsMap state:" + JSON.stringify(this.state.companyCodeToKyribaBankAccountsMap))
                            break;
                        case CONSTANT.RESPONSE_ERROR:
                            Logger.logError("Not able to query kyribaBankAccount information ");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                companyCodeToKyribaBankAccountsMap: data.data,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other Error when Querying kyribaBankAccount information");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying kyribaBankAccount information"
                        });
                    }
                }
            });

        // Get Kyriba Currency to Decimal Digit Mapping 
        var parameterGetKyribaCurrency = {dataType: CONSTANT.QUERY_STRING_PARAM_TYPE_KYRIBA_CURRENCY};
        APIClient.invoke('GET', 'queryKyribaData', parameterGetKyribaCurrency,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                currencyToDecimalDigitMapping: data.data
                            });
                            Logger.logInfo("currencyToDecimalDigitMapping state:" + JSON.stringify(this.state.currencyToDecimalDigitMapping))
                            break;
                        case CONSTANT.RESPONSE_SYSTEM_ERROR:
                            Logger.logError("Not able to query kyribaCurrency information");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other error occurred when querying for kyribaCurrency information: " + JSON.stringify(err));
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other error occurred when querying for kyribaCurrency information"
                        });
                    }
                }
            });

        // GET accountCategoryToRegionMapping
        var parameterGetSettlement = {indexString: CONSTANT.INDEX_STRING_REGION_MAPPING};

        APIClient.invoke('GET', 'payment', parameterGetSettlement,
            undefined,
            (err, data) => {
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                accountCategoryToRegionMap: data.data
                            });
                            Logger.logInfo("accountCategoryToRegionMap:" + JSON.stringify(this.state.accountCategoryToRegionMap))
                            break;
                        case CONSTANT.RESPONSE_ERROR:
                            Logger.logError("Response Error when Querying accountCategoryToRegionMap ");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                accountCategoryToRegionMap: data.data,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other Error when  Querying accountCategoryToRegionMap ");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying accountCategoryToRegionMap"
                        });
                    }
                }
            });

        //Get FxRequiringCurrencyMapping
        var parameterGetFxRequiringCurrencyMapping = {dataType:
            CONSTANT.QUERY_STRING_PARAM_TYPE_GENERAL_TRS_FX_REQUIRING_CURRENCY};

        APIClient.invoke('GET', 'generalTRSData', parameterGetFxRequiringCurrencyMapping,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                fxRequiringCurrencyMapping: data.data
                            });
                            Logger.logInfo("fxRequiringCurrencyMapping state:" + JSON.stringify(this.state.fxRequiringCurrencyMapping))
                            break;
                        case CONSTANT.RESPONSE_ERROR:
                            Logger.logError("Not able to query FXRequiringCurrency information ");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                fxRequiringCurrencyMapping: data.data,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other Error when Querying FXRequiringCurrency information");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying FXRequiringCurrency information"
                        });
                    }
                }
            });

        //Get WeekendCalendarMapping
        var parameterGetWeekendCalendarMapping = {dataType:
            CONSTANT.QUERY_STRING_PARAM_TYPE_GENERAL_TRS_FX_WEEKEND_CALENDAR};

        APIClient.invoke('GET', 'generalTRSData', parameterGetWeekendCalendarMapping,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                weekendCalendarMapping: data.data
                            });
                            Logger.logInfo("weekendCalendarMapping state:" + JSON.stringify(this.state.weekendCalendarMapping))
                            break;
                        case CONSTANT.RESPONSE_ERROR:
                            Logger.logError("Not able to query weekendCalendarMapping information ");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                weekendCalendarMapping: data.data,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other Error when Querying weekendCalendarMapping information");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying weekendCalendarMapping information"
                        });
                    }
                }
            });

        //Get HolidayCalendarMapping
        var parameterGetHolidayCalendarMapping = {dataType:
            CONSTANT.QUERY_STRING_PARAM_TYPE_GENERAL_TRS_FX_HOLIDAY_CALENDAR};

        APIClient.invoke('GET', 'generalTRSData', parameterGetHolidayCalendarMapping,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    switch (data.status) {
                        case CONSTANT.RESPONSE_SUCCESS:
                            this.setState({
                                holidayCalendarMapping: data.data
                            });
                            Logger.logInfo("holidayCalendarMapping state:" + JSON.stringify(this.state.holidayCalendarMapping))
                            break;
                        case CONSTANT.RESPONSE_ERROR:
                            Logger.logError("Not able to query holidayCalendarMapping information ");
                            this.setState({
                                status: CONSTANT.MODAL_QUERY_ERROR,
                                holidayCalendarMapping: data.data,
                                statusMsg: JSON.stringify(data['errorData'])
                            });
                            Logger.logInfo("Data error: " + JSON.stringify(data));
                            break;
                        default:
                    }
                } else {
                    Logger.logError("Other Error when Querying holidayCalendarMapping information");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying holidayCalendarMapping information"
                        });
                    }
                }
            });

        //Query RecordIdToDocumentIdMapping
        const paramGetRecordIdToDocumentIdMapping = {dataType:
            CONSTANT.QUERY_STRING_PARAM_TYPE_DOCUMENT_ID_MAPPING};

        APIClient.invoke('GET', '/attachDocuments/documentData', paramGetRecordIdToDocumentIdMapping,
            undefined,
            (err, data) => {
                this.setState({loading: false});
                if (!err) {
                    this.setState({
                        recordIdToDocumentIdMapping: data,
                        recordIdToDocumentIdMappingLoaded: true,
                    });
                    Logger.logInfo("recordIdToDocumentIdMaping state:" + JSON.stringify(this.state.recordIdToDocumentIdMapping))
                } else {
                    Logger.logError("Other Error when Querying recordIdToDocumentIdMapping information");
                    if (this.state.status != CONSTANT.MODAL_OTHER_ERROR) {
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Other System Error when Querying recordIdToDocumentIdMapping information"
                        });
                    }
                }
            });
    }

    // Handler for selection change in the data table
    onSelectionChange({detail}) {
        Logger.logInfo("onSelectionChange: " + JSON.stringify(detail));
        this.setState(() => {
            let commentObject = {};

            if (detail.selectedItems.length === 1) {
                detail.selectedItems.forEach((item) => {
                    commentObject["commentId"] = item[CONSTANT.TR_COL_COMMENT_ID];
                    commentObject["userComment"] = safeParseComments(item[CONSTANT.PR_COL_USER_COMMENTS], "queryHistoryPayment:select") || [];
                });

                return {
                    newComment: '',
                    commentsList: 1,
                    userComments: commentObject,
                    elementSelected: detail.selectedItems
                };
            } else {
                return {
                    newComment: '',
                    commentsList: detail.selectedItems.length,
                    userComments: {'userComment': [], 'commentId': ''},
                    elementSelected: detail.selectedItems
                };
            }
        });
        Logger.logInfo("State commentsList: " + JSON.stringify(this.state.commentsList));
    }

    // Handle Value Change in UI states
    handleValueChange = (name, value) => {
        this.setState({[name]: value});
    };

    //handle view Comment Click
    handleViewCommentClick = () => {
        Logger.logInfo("handleViewCommentClick: ");
        this.setState({commentVisible: true})
        Logger.logInfo("commentVisible: " + this.state.commentVisible);
    }

    // Handle Comment Update
    handleCommentUpdate = (event) => {
        Logger.logInfo("Comment event: " + JSON.stringify(event));
        this.setState({
            newComment: event.detail.value
        });
    }

    // Handle add comment in the comment dialog
    handleAddCommentClick = (elementSelected, newComment) => {
        Logger.logInfo("handleAddCommentClick: " + newComment);

        if (newComment) {
            let commentDate = FormatData.formateNewUTCCurrentTime();

            //Add the new comments to userComments field of the selected elements.
            elementSelected.map((entry, index) => {
                // The comment field is stored as serialized string, deserialize the string to get the userComments Object.
                let userCommentsList = safeParseComments(elementSelected[index][CONSTANT.PR_COL_USER_COMMENTS], "queryHistoryPayment:addComment"); if (userCommentsList === null) return;

                let newCommentObject = {};
                newCommentObject["Comment"] = newComment;
                newCommentObject["User"] = this.state.user;
                newCommentObject["CommentDate"] = commentDate;
                userCommentsList.push(newCommentObject);

                elementSelected[index][CONSTANT.PR_COL_USER_COMMENTS] = JSON.stringify(userCommentsList);
            })

            // Invoke update handler to call the update API endpoints.
            this.handleUpdate(elementSelected, 'AddComments');
            this.setState({commentVisible: false});
        } else {
            Logger.logInfo("No Comment: ");
            this.setState({commentVisible: true});
        }
    }

    handleDismissSingleUpload = () => {
        this.setState({
            singleUploadVisible: false,
        })
    }
    handleSingleDocumentClick = () => {
        this.setState({
            singleUploadVisible: true
        })
    }

    // Handle View UpdateWindow Click
    handleViewUpdateWindowClick = () => {
        Logger.logInfo("handleViewUpdateWindowClick: ");
        this.setState({updateWindowVisible: true})
        Logger.logInfo("updateWindowVisible: " + this.state.updateWindowVisible);
    }

    handleViewBatchUpdateWindowClick = () => {
        Logger.logInfo("handleViewBatchUpdateWindowClick: ");
        this.setState({batchUpdateWindowVisible: true})
        Logger.logInfo("batchUpdateWindowVisible: " + this.state.batchUpdateWindowVisible);
    }

    // Handle ConfirmUpdate  Click
    handleConfirmUpdateClick = (elementSelected) => {
        Logger.logInfo("handleConfirmUpdateClick: ");
        this.handleUpdate(elementSelected, "Update")
        this.setState({updateWindowVisible: false});
    }

    // Handle ConfirmUpdate  Click
    handleConfirmBatchUpdateClick = (elementSelected) => {
        Logger.logInfo("handleConfirmBatchUpdateClick: ");
        this.handleUpdate(elementSelected, "Update")
        this.setState({batchUpdateWindowVisible: false});
    }

    // Handle view downloadWindow click
    handleViewDownloadWindowClick = (button_id) => {
        Logger.logInfo("handleViewDownloadWindowClick: ");
        let ifDownloadAll = button_id === 'download_all' ? true : false;
        this.setState({
            downloadWindowVisible: true,
            ifDownloadAll: ifDownloadAll
        })
        Logger.logInfo("downloadWindowVisible: " + this.state.downloadWindowVisible);
    }

    // Handle confirm download click
    handleConfirmDownloadClick = (fileType, ifDownloadAll) => {
        Logger.logInfo("handleDownloadClick fileType: " + fileType);
        let fileName = "TRS_Settlements_Download" + FormatData.formatNewFileDate() + '.' + fileType;
        let delimiter = DOWNLOAD_FILE_PAYMENT_DELIMITER;
        let header = VISIBLE_COLUMN_OPTIONS_HISTORICAL_PAYMENT;
        let enrichedPayments;
        if (ifDownloadAll) {
            enrichedPayments = this.enrichPaymentsForDownload(this.state.distributions);
        } else {
            enrichedPayments = this.enrichPaymentsForDownload(this.state.elementSelected);
        }
        if (fileType === 'xlsx') {
            xlsxParser.writeFile(fileName, delimiter, enrichedPayments, header, fileType);
        } else if (fileType === 'csv') {
            xlsxParser.writeFileANSI(fileName, delimiter, enrichedPayments, header);
        }

        // Dismiss the download window
        this.setState({downloadWindowVisible: false})
    }

    /*  Enrich Payment for Download
        Since some fields displayed the table are not contained in the elementSelected/distribution object
        and are retrieved elsewhere instead,
        this function enrich those fields so that all the columns displayed in the table can be downloaded. */
    enrichPaymentsForDownload = (elementSelected) => {
        // Prepare a deep clone of elementSelected.
        let elementSelectedCopy = JSON.parse(JSON.stringify(elementSelected))
        let enrichedPayments =  elementSelectedCopy.map(payment => {
            // Enrich some fields of each of the payment element.
            VISIBLE_COLUMN_OPTIONS_HISTORICAL_PAYMENT.forEach((column) => {
                if (column === CONSTANT.PR_COL_RECEIVING_AMOUNT ||
                    column === CONSTANT.PR_COL_SENDING_AMOUNT ||
                    column === CONSTANT.PR_COL_SETTLEMENT_USD_EQUIV ||
                    column === CONSTANT.PR_COL_TARGET_AMOUNT) {
                    //pass
                } else if (column === CONSTANT.PR_COL_UPLOAD_DATE ||
                    column === CONSTANT.PR_COL_CREATION_DATE ||
                    column === CONSTANT.PR_COL_UPDATE_DATE ||
                    column === CONSTANT.PR_COL_APPROVAL_DATE ||
                    column === CONSTANT.PR_COL_REJECTION_DATE ||
                    column === CONSTANT.PR_COL_EXPORT_DATE ||
                    column === CONSTANT.PR_COL_DUE_DATE) {
                    //Format UTC ISO DateString (Used in DDB) to local timezone DateString
                    payment[column] = FormatData.formatISODateToPSTTimezoneDate(payment[column]);
                } else if (column === 'Latest Comment') {
                    payment[column] = getLatestComment(payment);
                } else if (column === 'Sending Region' || column === 'Receiving Region') {
                    payment[column] = populateRegion(payment, column);
                } else if (column === 'Sending Branch') {
                    payment[column] = lookupBranch(payment[CONSTANT.PR_COL_SENDING_ACCOUNT],
                        payment[CONSTANT.PR_COL_SENDING_CO], this.state.companyCodeToKyribaBankAccountsMap);
                } else if (column === 'Receiving Branch') {
                    payment[column] = lookupBranch(payment[CONSTANT.PR_COL_RECEIVING_ACCOUNT],
                        payment[CONSTANT.PR_COL_RECEIVING_CO], this.state.companyCodeToKyribaBankAccountsMap);
                } else if (column === 'File Attached'){
                    payment[column] = hasDocumentAttached(payment[CONSTANT.PR_COL_SETTLEMENT_ID],
                        this.state.recordIdToDocumentIdMapping) ? 'Yes' : 'No';
                }
            });
            // If the payment element contain a key that's not in VISIBLE_COLUMN_OPTIONS_OPEN_PAYMENT, remove the value.
            for (const key in payment) {
                if (!VISIBLE_COLUMN_OPTIONS_HISTORICAL_PAYMENT.includes(key)) {
                    delete payment[key];
                }
            }
            return payment;
        })
        return enrichedPayments;
    }

    // Handle Dismiss or Cancel for modals' window
    handleDismissClick = () => {
        Logger.logInfo("handleDismissClick Start: ");
        if (this.state.commentVisible) {
            this.setState({commentVisible: false})
        } else if (this.state.updateWindowVisible) {
            this.setState({updateWindowVisible: false})
        } else if (this.state.batchUpdateWindowVisible){
            this.setState({batchUpdateWindowVisible: false})
        } else if (this.state.downloadWindowVisible) {
            this.setState({downloadWindowVisible: false})
        }
    }

    handleDismissDocumentModalClick = () => {
        this.setState({
            documentVisible: false,
        })
    }

    // Main handler for updating settlements
    handleUpdate = (elementSelected, name) => {
        Logger.logInfo("handleUpdate elementSelected: " + JSON.stringify(elementSelected)
            + " name: " + name);

        this.setState({
            status: CONSTANT.MODAL_SUBMITTING
        });

        let newData = this.state.distributions;
        let updateSuccessState = CONSTANT.MODAL_PAYMENT_UPDATE_SUCCESS;

        //Update the Selected Element Values
        elementSelected.map((entry, index) => {
            var objIndex = newData.findIndex((obj => obj[CONSTANT.PR_COL_SETTLEMENT_ID] === entry[CONSTANT.PR_COL_SETTLEMENT_ID]));

            if (name === "Export") {
                //For Exporting payment set the status as Exported.
                elementSelected[index][CONSTANT.PR_COL_STATUS] = CONSTANT.PAYMENT_STATUS_EXPORTED;
                elementSelected[index][CONSTANT.PR_COL_EXPORT_DATE] = FormatData.formateNewUTCCurrentTime();
                elementSelected[index][CONSTANT.PR_COL_EXPORTED_BY] = this.state.user;
            }

            // Capture the user who made the latest edits.
            elementSelected[index][CONSTANT.PR_COL_UPDATE_DATE] = FormatData.formateNewUTCCurrentTime();
            elementSelected[index][CONSTANT.PR_COL_UPDATE_BY] = this.state.user;

            newData[objIndex] = entry;
        })
        Logger.logInfo("newData: " + JSON.stringify(newData));

        var parameter = {
            indexString: CONSTANT.INDEX_STRING_HISTORIC_PAYMENT_REVIEW,
            userGroup: this.state.userGroup,
            fromValue: this.state.fromValue,
            toValue: this.state.toValue
        }

        Logger.logInfo("elementSelected: " + JSON.stringify(elementSelected));
        APIClient.invoke('POST', 'payment', parameter, elementSelected, (err, requestData) => {
            Logger.logInfo("Response data: " + JSON.stringify(requestData));
            if (!err && requestData && typeof requestData === 'object') {
                switch (requestData.status) {
                    case CONSTANT.RESPONSE_SUCCESS:
                        this.setState({
                            status: updateSuccessState,
                            distributions: requestData.data,
                            elementSelected: []
                        });
                        Logger.logInfo("Update distributions state: " + JSON.stringify(this.state.distributions));
                        break;
                    case CONSTANT.RESPONSE_ERROR:
                        Logger.logError("Error updating payment records with payments list = " + elementSelected.toString());
                        this.setState({
                            status: CONSTANT.MODAL_UPDATE_ERROR,
                            statusMsg: requestData['errorData'] || "An error occurred while updating the settlement."
                        });
                        break;
                    case CONSTANT.RESPONSE_SYSTEM_ERROR:
                        Logger.logError("System Error when updating payment records with payments list = " + elementSelected.toString());
                        this.setState({
                            status: CONSTANT.MODAL_SYSTEM_ERROR,
                            statusMsg: requestData['errorData'] || "A system error occurred."
                        });
                        break;
                    case CONSTANT.MODAL_REQUEST_ERROR:
                        this.setState({
                            status: CONSTANT.MODAL_REQUEST_ERROR,
                            statusMsg: requestData['errorData'] || "Request error."
                        });
                        break;
                    default:
                        Logger.logError("Unexpected response status: " + requestData.status);
                        this.setState({
                            status: CONSTANT.MODAL_OTHER_ERROR,
                            statusMsg: "Unexpected error occurred while updating the settlement."
                        });
                }
            } else {
                Logger.logError("Error or invalid response when updating payment records. err: " + JSON.stringify(err) + ", requestData: " + JSON.stringify(requestData));
                this.setState({
                    status: CONSTANT.MODAL_OTHER_ERROR,
                    statusMsg: "Failed to update settlement. Please try again."
                });
            }
        })
    };

    // Configure column definitions & table configurations for displaying historical settlement data.
    getColumnDefinitionsAndTableConfiguration = () => {
        let columnDefinitions = [];
        let sortableColumns = [];
        let visibleColumnOption = [];
        let firstOption = {};
        firstOption['label'] = 'Properties';
        let filterOptions = [];
        let contentSelectorOptions = [];

        VISIBLE_COLUMN_OPTIONS_HISTORICAL_PAYMENT.forEach((column) => {
            let columnDefinitionsItem = {};
            let sortableColumnsItem = {};
            let filterColumnOptionItem = {};
            columnDefinitionsItem['id'] = column;
            columnDefinitionsItem['header'] = column;
            columnDefinitionsItem['width'] = 180;

            if (column === CONSTANT.PR_COL_RECEIVING_AMOUNT ||
                column === CONSTANT.PR_COL_SENDING_AMOUNT ||
                column === CONSTANT.PR_COL_SETTLEMENT_USD_EQUIV ||
                column === CONSTANT.PR_COL_TARGET_AMOUNT) {
                //Format USD amount into Display format
                columnDefinitionsItem['cell'] = (item => <Box textAlign='right'>
                    {FormatData.formatUSDDisplayAmountAccounting(item[column])}</Box>);
            } else if (column === CONSTANT.PR_COL_UPLOAD_DATE ||
                column === CONSTANT.PR_COL_CREATION_DATE ||
                column === CONSTANT.PR_COL_UPDATE_DATE ||
                column === CONSTANT.PR_COL_APPROVAL_DATE ||
                column === CONSTANT.PR_COL_REJECTION_DATE ||
                column === CONSTANT.PR_COL_EXPORT_DATE ||
                column === CONSTANT.PR_COL_DUE_DATE) {
                //Format UTC ISO DateString (Used in DDB) to local timezone DateString
                columnDefinitionsItem['cell'] = (item => FormatData.formatISODateToPSTTimezoneDate(item[column]));
            } else if (column === 'Latest Comment') {
                columnDefinitionsItem['cell'] = (item => getLatestComment(item));
            } else if (column === 'Sending Region' || column === 'Receiving Region') {
                columnDefinitionsItem['cell'] = (item => populateRegion(item, column));
            } else if (column === 'Sending Branch') {
                columnDefinitionsItem['cell'] = (item => lookupBranch(item[CONSTANT.PR_COL_SENDING_ACCOUNT],
                    item[CONSTANT.PR_COL_SENDING_CO], this.state.companyCodeToKyribaBankAccountsMap));
            } else if (column === 'Receiving Branch') {
                columnDefinitionsItem['cell'] = (item => lookupBranch(item[CONSTANT.PR_COL_RECEIVING_ACCOUNT],
                    item[CONSTANT.PR_COL_RECEIVING_CO], this.state.companyCodeToKyribaBankAccountsMap));
            } else if (column === 'File Attached'){
                columnDefinitionsItem['cell'] = (item =>
                    hasDocumentAttached(item[CONSTANT.PR_COL_SETTLEMENT_ID],
                        this.state.recordIdToDocumentIdMapping) ? 'Yes' : 'No');
            } else {
                columnDefinitionsItem['cell'] = (item => item[column]);
            }

            // Sortable Columns
            sortableColumnsItem['id'] = column;
            sortableColumnsItem['field'] = column;
            sortableColumns.push(sortableColumnsItem);

            // Filtering Options:
            filterColumnOptionItem['propertyLabel'] = column;
            if (column === 'Sending Region') {
                filterColumnOptionItem['propertyKey'] = CONSTANT.PR_COL_REGION;
            } else {
                filterColumnOptionItem['propertyKey'] = column;
            }
            filterColumnOptionItem['groupValuesLabel'] = column + " values";
            filterColumnOptionItem['values'] = [];

            // Remove columns that are rendered on the front end
            if (column !== 'File Attached') {
                filterOptions.push(filterColumnOptionItem);
            }

            // ColumnDefinitionsItem['minWidth'] = '100px';
            columnDefinitions.push(columnDefinitionsItem);

            // Content Selector Columns
            let contentSelectorItem = {};

            contentSelectorItem['id'] = column;
            contentSelectorItem['label'] = column;
            contentSelectorItem['editable'] = true;
            contentSelectorItem['visible'] = true;


            contentSelectorOptions.push(contentSelectorItem);
        });

        firstOption['options'] = contentSelectorOptions;
        visibleColumnOption.push(firstOption);

        return {
            visibleColumnOption,
            sortableColumns,
            columnDefinitions,
            filterOptions
        }
    }

    /* Handler for search button clicked */
    handleConfirmSearch = () => {
        let startDate = new Date(this.state.fromValue);
        let endDate = new Date(this.state.toValue);

        if (endDate <startDate) {
            this.setState({
                status: CONSTANT.MODAL_QUERY_RANGE_ERROR
            });
            return;
        }

        this.handleQueryHistoricalSettlements();
    }

    render() {

        /**
         * If the user is in more than 1 IC Settlements LDAP group,
         * Display a Polaris alert to prompt them to remove themselves
         * from all but 1 group.
         */
        if (this.state.icLdapOverlap.length > 1) {
            return ldapMembershipAlert(this.state.icLdapOverlap);
        }

        let searchBar =
            <Container>
                <ColumnLayout columns={3}>
                        <div>
                            <FormField
                                description="Specify the range start of the search"
                                label="From Value Date*">
                                <DatePicker
                                    onChange={event => {
                                        this.setState({ fromValue: event.detail.value })
                                        Logger.logInfo("fromValue after change: " + this.state.fromValue)
                                    }}
                                    value={this.state.fromValue}
                                    nextMonthAriaLabel="Next month"
                                    placeholder="YYYY/MM/DD"
                                    previousMonthAriaLabel="Previous month"
                                    todayAriaLabel="Today"/>
                            </FormField>
                        </div>
                        <div>
                            <FormField
                                description="Specify the range end of the search"
                                label="To Value Date*">
                                <DatePicker
                                    onChange={event => {
                                        this.setState({ toValue: event.detail.value })
                                        Logger.logInfo("toValue after change: " + this.state.toValue)
                                    }}
                                    value={this.state.toValue}
                                    nextMonthAriaLabel="Next month"
                                    placeholder="YYYY/MM/DD"
                                    previousMonthAriaLabel="Previous month"
                                    todayAriaLabel="Today"/>
                            </FormField>
                        </div>
                        <div>
                            <Box float="left">
                                <Button variant="primary"
                                        iconName="angle-right"
                                        iconAlign="right"
                                        onClick={this.handleConfirmSearch}>Search</Button>
                            </Box>
                        </div>
                </ColumnLayout>
            </Container>;

        /**
         * Display the Single Upload Document Module.
         */
        if (this.state.singleUploadVisible === true) {
            return <SingleDocumentModule id={this.state.elementSelected[0][CONSTANT.PR_COL_SETTLEMENT_ID]}
                                         handleDismissSingleUpload ={this.handleDismissSingleUpload}
            />
        }

        let {visibleColumnOption, sortableColumns, columnDefinitions, filterOptions} = this.getColumnDefinitionsAndTableConfiguration();

        return (
            <div>
                <Form>
                    {this.state.documentVisible === true && this.state.documentData.length > 0 &&
                    <QueryDocumentData distributions={this.state.documentData}
                                       handleDismissDocumentModalClick={this.handleDismissDocumentModalClick}
                                       columnDefinitions={columnDefinitions}
                                       contentSelectorOptions={visibleColumnOption}
                                       filterOptions={filterOptions}
                                       elementSelected={this.state.elementSelected}
                                       onSelectionChange={this.onSelectionChange}
                                       sortableColumns={sortableColumns}
                    />}
                    {this.state.documentVisible === true && this.state.documentData.length === 0 &&
                    <NoDocumentModal handleDismissDocumentModalClick={this.handleDismissDocumentModalClick}/>}
                    <HistoryPaymentDataContentBlock distributions={this.state.distributions}
                                                    onRowClick={this.onRowClick}
                                                    searchBar={searchBar}
                                                    feedbackMessage={getFeedbackMessage(this.state.status, this.state.statusMsg)}
                                                    elementSelected={this.state.elementSelected}
                                                    contentSelectorOptions={visibleColumnOption}
                                                    sortableColumns={sortableColumns}
                                                    columnDefinitions={columnDefinitions}
                                                    filterOptions={filterOptions}
                                                    userGroup={this.state.userGroup}
                                                    user={this.state.user}
                                                    onSelectionChange={this.onSelectionChange}
                                                    handleUpdateClick={this.handleUpdate}
                                                    handleValueChange={this.handleValueChange}
                                                    handleDismissClick={this.handleDismissClick}
                                                    companyCodeToKyribaBankAccountsMap={this.state.companyCodeToKyribaBankAccountsMap}
                                                    disableOverrideButton={this.state.disableOverrideButton}
                                                    //User Comments Modal Related
                                                    commentVisible={this.state.commentVisible}
                                                    newComment={this.state.newComment}
                                                    userComments={this.state.userComments}
                                                    commentsList={this.state.commentsList}
                                                    handleViewCommentClick={this.handleViewCommentClick}
                                                    handleAddCommentClick={this.handleAddCommentClick}
                                                    handleCommentUpdate={this.handleCommentUpdate}
                                                    //Update Modal Related
                                                    handleViewUpdateWindowClick={this.handleViewUpdateWindowClick}
                                                    handleConfirmUpdateClick={this.handleConfirmUpdateClick}
                                                    updateWindowVisible={this.state.updateWindowVisible}
                                                    accountCategoryToRegionMap={this.state.accountCategoryToRegionMap}
                                                    fxRequiringCurrencyMapping={this.state.fxRequiringCurrencyMapping}
                                                    weekendCalendarMapping={this.state.weekendCalendarMapping}
                                                    holidayCalendarMapping={this.state.holidayCalendarMapping}
                                                    currencyToDecimalDigitMapping={this.state.currencyToDecimalDigitMapping}
                                                    //Batch Update Modal Related
                                                    handleViewBatchUpdateWindowClick={this.handleViewBatchUpdateWindowClick}
                                                    handleConfirmBatchUpdateClick={this.handleConfirmBatchUpdateClick}
                                                    batchUpdateWindowVisible={this.state.batchUpdateWindowVisible}
                                                    //Download Modal Related
                                                    handleViewDownloadWindowClick={this.handleViewDownloadWindowClick}
                                                    downloadWindowVisible={this.state.downloadWindowVisible}
                                                    ifDownloadAll={this.state.ifDownloadAll}
                                                    handleConfirmDownloadClick={this.handleConfirmDownloadClick}
                                                    handleQueryDocument={this.handleQueryDocument}
                                                    recordIdToDocumentIdMapping={this.state.recordIdToDocumentIdMapping}
                                                    //Single Document Upload
                                                    handleSingleDocumentClick={this.handleSingleDocumentClick}
                                                    loadedMappings={this.state.loadedMappings}

                    />
                </Form>
            </div>);
    }
}

export default QueryHistoryPaymentData;